import { Trans } from 'react-i18next';

import { Patient } from '@dreryk/egabinet-patient-frontend-api';
import { PatientMedicine } from '@dreryk/egabinet-prescription-frontend-api';
import { VisitDiagnosis } from '@dreryk/egabinet-visit-frontend-api';

import { Anchor, AnchorAlignment, EmptyStatePlaceholder, Table, TableKeyExtractor } from '@dreryk/react-components';

import { medicineSelectorTranslationKeys } from '../../../../../translations';
import { OnMedicineSelection } from '../../../PrescriptionIssuingPanel.types';
import { useMedicineSelectorTableColumns } from '../MedicineSelectorTable.hooks';
import { MedicineSelectorTableDataAccessor } from '../MedicineSelectorTableDataAccessor';

import { FavoriteMedicinesSelectorNoResultsHeartIcon } from './FavoriteMedicinesSelectorNoResultsHeartIcon/FavoriteMedicinesSelectorNoResultsHeartIcon';
import { useFavoriteMedicinesSelectorConfiguration } from './FavoriteMedicinesSelectorTable.hooks';

export const keyExtractor: TableKeyExtractor<PatientMedicine> = (bean) => bean.medicine.id;

export type FavouriteMedicinesSelectorTableProps = {
   readonly patientId: Patient['id'];
   readonly onMedicineSelection: OnMedicineSelection;
   readonly visitDiagnoses: VisitDiagnosis[];
};

export const FavoriteMedicinesSelectorTable = (props: FavouriteMedicinesSelectorTableProps): JSX.Element => {
   const dataConfiguration = useFavoriteMedicinesSelectorConfiguration(props.patientId);
   const columns = useMedicineSelectorTableColumns(
      props.onMedicineSelection,
      props.patientId,
      dataConfiguration.refetch,
      props.visitDiagnoses,
      true
   );

   return (
      <>
         <Anchor shouldPerformScroll verticalAlignment={AnchorAlignment.START} testId={'noFavoriteMedicines'} />
         <Table<PatientMedicine>
            columns={columns}
            dataConfiguration={dataConfiguration}
            keyExtractor={keyExtractor}
            dataAccessor={MedicineSelectorTableDataAccessor}
            placeholder={
               <EmptyStatePlaceholder
                  heading={medicineSelectorTranslationKeys.table.noFavoriteMedicines}
                  subheading={
                     <Trans
                        i18nKey={medicineSelectorTranslationKeys.table.noFavoriteMedicinesResults}
                        components={{
                           heartIcon: <FavoriteMedicinesSelectorNoResultsHeartIcon />,
                        }}
                     />
                  }
                  testId={'noFavoriteMedicines'}
               />
            }
            testId={'favoriteMedicines'}
         />
      </>
   );
};
